import request from '@/plugins/request';

// 大数据平台中心统计API

/**
 * 获取仪表盘摘要数据
 */
export function getDashboardSummary(params) {
  return request({
    url: '/api/stats/dashboard-summary',
    method: 'get',
    params
  });
}

export function updateDashboardSummary(data) {
  return request({
    url: '/api/stats/dashboard-summary',
    method: 'put',
    data
  });
}

export function getDashboardUsers() {
  return request({
    url: '/api/stats/dashboard-users',
    method: 'get'
  });
}

/**
 * 获取趋势数据
 * @param {number} days - 获取最近多少天的数据，默认30天
 */
export function getTrendData(days = 30) {
  return request({
    url: '/api/stats/trend-data',
    method: 'get',
    params: {
      days
    }
  });
}

/**
 * 获取平台分布数据
 */
export function getPlatformDistribution() {
  return request({
    url: '/api/stats/platform-distribution',
    method: 'get'
  });
}
